import writeXlsxFile from "write-excel-file/browser";

const MAX_SHEET_NAME_LENGTH = 31;
const DEFAULT_SHEET_NAME = "Relatório";
const INVALID_SHEET_NAME_CHARS = /[\\/?*[\]:]/g;

const normalizeSheetName = (sheetName, index) => {
    const fallback = index === 0 ? DEFAULT_SHEET_NAME : `${DEFAULT_SHEET_NAME} ${index + 1}`;
    const normalizedName = String(sheetName || fallback)
        .replace(INVALID_SHEET_NAME_CHARS, "-")
        .trim();

    return (normalizedName || fallback).substring(0, MAX_SHEET_NAME_LENGTH);
};

const normalizeCellValue = (value) => {
    if (value === undefined || value === null) return null;
    if (value instanceof Date) return value;
    if (["string", "number", "boolean"].includes(typeof value)) return value;

    return String(value);
};

const getObjectKeys = (data) => {
    const keys = new Set();

    data.forEach(row => {
        Object.keys(row ?? {}).forEach(key => keys.add(key));
    });

    return Array.from(keys);
};

export const rowsFromObjects = (data = []) => {
    const columns = getObjectKeys(data);

    if (!columns.length) return [];

    return [
        columns,
        ...data.map(row => columns.map(column => normalizeCellValue(row?.[column])))
    ];
};

export const exportXlsx = async ({ fileName, sheets }) => {
    const normalizedSheets = sheets.map((sheet, index) => ({
        data: sheet.rows ?? rowsFromObjects(sheet.data),
        sheet: normalizeSheetName(sheet.name, index)
    }));

    await writeXlsxFile(normalizedSheets).toFile(fileName);
};

export const exportObjectsToXlsx = ({ fileName, sheetName, data }) => exportXlsx({
    fileName,
    sheets: [{ name: sheetName, data }]
});
